export const APIRoutes = {
  LOGGER: 'logger/external/api/'
};
